import React, { useState, useEffect }  from 'react'
import { Col, Container, Row, Image } from 'react-bootstrap'
import { Card as CardElement } from 'antd'
import CardFlip from 'react-card-flip'
import { APIMEDIA_HOST } from '../../../conf/hosts'
import { getCardCols, ICardCols } from '../../common/exerciseHelper'
import { Card } from '../ntfSlice'
import { getCardKeys } from '../ntfHelper'
import styled from 'styled-components'
import { ReactFitty } from "react-fitty";

export interface INtfGameProps {
  level?: number
  cards?: Card[]
  cardBack?: string
  gameCompleted: (attempts: number) => void
}

const cardColsMin: ICardCols = {
  xs: 6,
  sm: 4,
  md: 3,
  lg: 2,
}


const NameCard = styled(CardElement)`
  aspect-ratio: 510 / 690;
  display: flex;
  justify-content: center; 
  align-items: center;
  aspect-ratio: 510 / 690;
  padding: 0.4rem;                
  box-sizing: border-box;
  background:
    linear-gradient(#EAF1FD, #EAF1FD) content-box,
    radial-gradient(79% 64% at 50% 50%, #f5f2e6, #aa1c20) border-box !important;
  .ant-card-body {
    padding: 2px;
    width: 100%;
    overflow: hidden;
    text-align: center;
  }
  .card-name {
    font-family: Helvetica, Arial, sans-serif;
    font-weight: bolder;
  }
`

const CardImage = styled(Image)`
  aspect-ratio: 510 / 690;
  padding: 0.4rem;               
  box-sizing: border-box;
  background:
    linear-gradient(#EAF1FD, #EAF1FD) content-box,
    radial-gradient(79% 64% at 50% 50%, #f5f2e6, #aa1c20) border-box;
`


const NtfGame = ({level, cards, cardBack, gameCompleted}: INtfGameProps) => {
  const [allCards, setAllCards] = useState<string[]>([])
  const [openedCards, setOpenedCards] = useState<string[]>([])
  const [currentCards, setCurrentCards] = useState<string[]>([])
  const [attempts, setAttempts] = useState<number>(0)

  useEffect(() => {
    if (cards) {
      const cardKeys = getCardKeys(cards, level)
      setAllCards(cardKeys)
    }
  }, [cards, level])

  useEffect(() => {
    if (allCards.length > 0 && openedCards.length === allCards.length) {
      setTimeout(() => {
        gameCompleted(attempts)
        setOpenedCards([])
        setCurrentCards([])
        setAttempts(0)
      }, 800)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openedCards])

  useEffect(() => {
    if (currentCards.length === 2) {
      if (currentCards[0][0] === currentCards[1][0]) {
        setOpenedCards([...openedCards, ...currentCards])
        setCurrentCards([])
      } else {
        setTimeout(() => {
          setCurrentCards([])
        }, 1000)
      }
    }
  }, [currentCards, allCards, openedCards])

  if (cards === undefined || cardBack === undefined || cards.length === 0) { return null }

  const handleFlipCard = (key: string) => {
    if (currentCards.length < 2) {
      setCurrentCards([...currentCards, key])
      setAttempts(attempts + 1)
    }
  }

  const getCardComponent = (key: string) => {
    const index: number = parseInt(key.substring(0, key.length - 1))
    const cardType: string = key[key.length-1]
    const card: Card = cards[index]
    if (cardType === 'F') {
      return (
        <CardImage draggable={false} src={`${APIMEDIA_HOST}${card.card}`} fluid className="text-center" width="500px" rounded />
      )
    }
    if (cardType === 'N') {
      return (
        <NameCard className="rounded"><ReactFitty maxSize={30} className="card-name">{card.name}</ReactFitty></NameCard>
      )
    }
  }

  const cardCols = allCards.map((card) => {
    const isFlipped = openedCards.indexOf(card) >= 0 || currentCards.indexOf(card) >= 0
    return (
      <Col key={`card-${card}`} {...getCardCols(allCards.length, cardColsMin)} className="my-3">
        <CardFlip isFlipped={isFlipped} containerStyle={{height: "100%"}}>
          <CardImage draggable={false} src={`${APIMEDIA_HOST}${cardBack}`} fluid onClick={() => handleFlipCard(card)} className="text-center" width="500px" rounded />
          {getCardComponent(card)}
        </CardFlip>
      </Col>
    )
  })

  return (
    <Container>
      <Row>
        {cardCols}
      </Row>
    </Container>
  )
}

export default NtfGame